import React from "react";
import { cx } from "emotion";
import { CLASSNAME_PREFIX } from "./classname";
import "../../Styles/Modal.scss";

export const ModalBody: React.FC<React.HTMLProps<HTMLDivElement>> = props => (
  <div className={`${CLASSNAME_PREFIX}body-wrapper`}>
    <div className={cx(`${CLASSNAME_PREFIX}body`, props.className)} {...props}>
      {props.children}
    </div>
  </div>
);
